export const getValidDate = (date: string) => (date ? new Date(date) : new Date(Date.now()));
